import { Fragment, useContext, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import { menuRoutes } from "../../../router/menu";
import PageHeader from "../../../layout/shared/page-header";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import CategoryList from "./CategoryList";
import { Category } from "../../../type/entities/category-type";

const CategoriesListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [categorySelected, setCategorySelected] = useState<Category | null>(null);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de categorias' },
        { name: 'Categorias', href: menuRoutes.categories.path },  
    ];

    const defaultFilters = {};

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Listado de categorias" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'category') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setIsOpenFormDrawer(true) 
                                    setCategorySelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear categoria
                            </Button>
                        )
                    }
                </PageHeader>
                <CategoryList openFormDrawer={isOpenFormDrawer} setOpenFormDrawer={setIsOpenFormDrawer} categorySelected={categorySelected} setCategorySelected={setCategorySelected} />
            </FiltersProvider>
        </Fragment>
    );
};

export default CategoriesListWrapper;